import { type StateCreator } from 'zustand';

/**
 * Written only on create-workspace. Missing keys must not mount the intro —
 * existing users on a new browser have empty storage.
 */
export type ShouldMountOnboardingIntroSlice = {
  shouldMountOnboardingIntro: Record<string, boolean>;
  setShouldMountOnboardingIntro: ({ workspaceId, value }: { workspaceId: string; value: boolean }) => void;
};

export const createShouldMountOnboardingIntroSlice: StateCreator<
  ShouldMountOnboardingIntroSlice,
  [],
  [],
  ShouldMountOnboardingIntroSlice
> = (set) => ({
  shouldMountOnboardingIntro: {},
  setShouldMountOnboardingIntro: ({ workspaceId, value }) =>
    set((state) => ({
      shouldMountOnboardingIntro: { ...state.shouldMountOnboardingIntro, [workspaceId]: value },
    })),
});
